import { createI18n } from 'vue-i18n'

// --- VERSION 1 (Legacy) ---
import esContractTypes from './Dictionaries/Spanish/contractTypes.json'
import esMessages from './Dictionaries/Spanish/messages.json'
import esExceptions from './Dictionaries/Spanish/exceptions.json'
import esViewDescriptions from './Dictionaries/Spanish/viewDescriptions.json'
import enContractTypes from './Dictionaries/English/contractTypes.json'
import enMessages from './Dictionaries/English/messages.json'
import enExceptions from './Dictionaries/English/exceptions.json'
import enViewDescriptions from './Dictionaries/English/viewDescriptions.json'

const legacyMessages = {
  es: { ...esContractTypes.es, ...esExceptions.es, ...esMessages.es, ...esViewDescriptions.es },
  en: { ...enContractTypes.en, ...enExceptions.en, ...enMessages.en, ...enViewDescriptions.en },
}
// --- VERSION 2 (Auto-load) ---
const loadV2Messages = () => {
  const v2 = { es: {}, en: {} }

  try {
    const context = require.context('./v2', true, /\.json$/)

    context.keys().forEach((key) => {
      const parts = key.split('/')
      const lang = parts[1]
      const fileName = parts[2].replace('.json', '')

      if (v2[lang]) {
        v2[lang][fileName] = context(key)
      }
    })
  } catch (e) {
    console.warn('No se pudieron cargar los archivos de la V2', e)
  }

  return v2
}

const v2Messages = loadV2Messages()

const finalMessages = {
  es: { ...legacyMessages.es, ...v2Messages.es },
  en: { ...legacyMessages.en, ...v2Messages.en },
}

const lang = localStorage.getItem('lang') || 'es'

const i18n = createI18n({
  locale: lang,
  messages: finalMessages,
  fallbackLocale: 'es',
  legacy: false,
})

export default i18n
